import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import api from "../../api";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { notify } from "../../utils/toast";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import axios from "axios";

export const AdminContact = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({});
  const [page, setPage] = useState(1);

  const getData = async () => {
    try {
      let payload = {
        page: page,
      };
      let token = localStorage.getItem("admintoken");
      axios.defaults.headers.common["Authorization"] = token;
      const response = await api.contactGetAll(payload);
      console.log(response);
      if (response?.success) {
        setData(response?.contacts || []);
        setPagination(response?.pagination || []);
      }
    } catch (error) {
      notify.error(error?.message || "Something went wrong");
    }
  };

  useEffect(() => {
    getData();
  }, [page]);

  return (
    <>
      {/* Begin Page Content */}
      <div className="DashboardMain">
        <div className="row">
          <div className="col">
            <h3>Contact Form Data</h3>
            <Table
              data={data}
              getData={getData}
              pagination={pagination}
              setPage={setPage}
              page={page}
            />
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
    </>
  );
};

const Table = ({ data, page, setPage, getData, pagination }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  return (
    <>
      <div className="TableMain mt-3">
        <div className="table-responsive">
          <table className="table table-hover drivers-table">
            <thead>
              <tr>
                <th scope="col" className="">
                  First Name
                </th>
                <th scope="col" className="">
                  Last Name
                </th>
                <th scope="col" className="">
                  Email
                </th>
                <th scope="col" className="">
                  Phone
                </th>
                <th scope="col" className="">
                  Message
                </th>
                <th scope="col" className="">
                  Submit At
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, key) => (
                <tr key={key}>
                  <td>
                    <div className="table-text-dark w-max-c db">
                      {item?.firstName}
                    </div>
                  </td>

                  <td>
                    <span className="table-text-dark">{item?.lastName}</span>
                  </td>
                  <td>
                    <span className="table-text-dark">{item?.email}</span>
                  </td>
                  <td>
                    <span className="table-text-dark">{item?.phone}</span>
                  </td>

                  <td>
                    <span className="table-text-dark taskDesc">
                      {item?.message}
                    </span>
                  </td>
                  <td>
                    <div className="table-text-dark w-max-c db">
                      {item?.createdAt ? formatDate(item?.createdAt) : "-"}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="d-flex justify-content-center my-4">
          <Stack spacing={2}>
            <Pagination
              count={pagination?.pages || 1}
              page={page || 1}
              onChange={handleChange}
            />
          </Stack>
        </div>
      </div>
    </>
  );
};
